import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ChecklistItemViewModel } from '../../models/checklists/checklistItemViewModel';
import { ValidatedViewModel } from '../../viewModels/validatedViewModel';
import { ChecklistItemService } from '../checklist-item-service';
import { ChecklistItemAbstraction } from './checklist-item.abstraction';

/**
 * Implementation for normal authenticated users
 * Delegates to the existing ChecklistItemService
 */
@Injectable({
  providedIn: 'root',
})
export class NormalUserChecklistService extends ChecklistItemAbstraction {
  constructor(private checklistItemService: ChecklistItemService) {
    super();
  }

  add(checklistItem: ChecklistItemViewModel): Observable<ValidatedViewModel> {
    return this.checklistItemService.add(checklistItem);
  }

  update(checklistItem: ChecklistItemViewModel, externalShareId?: string): Observable<ChecklistItemViewModel> {
    return this.checklistItemService.update(checklistItem);
  }

  updateItems(checklistItems: ChecklistItemViewModel[], externalShareId?: string): Observable<ChecklistItemViewModel[]> {
    return this.checklistItemService.updateItems(checklistItems);
  }

  delete(checklistItemId: number): Observable<ChecklistItemViewModel> {
    return this.checklistItemService.delete(checklistItemId);
  }

  getList(): Observable<ChecklistItemViewModel[]> {
    return this.checklistItemService.getList();
  }

  getListByGlobalObjectId(globalObjectId: number, globalObjectType: number, externalShareId?: string): Observable<ChecklistItemViewModel[]> {
    return this.checklistItemService.getListByGlobalObjectId(globalObjectId, globalObjectType);
  }

  addFromTemplate(
    checklistTemplateIds: number[],
    globalObjectId: number,
    globalObjectType: number
  ): Observable<ChecklistItemViewModel[]> {
    return this.checklistItemService.addFromTemplate(checklistTemplateIds, globalObjectId, globalObjectType);
  }
}
